import React from 'react';
import { FetchBannerParams } from 'store/product/types';

import Loadable from './Loadable';

interface Props {
  banners?: any[];
  bannersEnabled: boolean;
  fetchBanners: (params: FetchBannerParams) => Promise<void>;
  productId: string;
  isPaginationEnabled?: boolean;
  remainingInventoryIds?: string[];
  queryParamsObject?: object;
  hasUniversalBanners?: boolean;
}

function Switch({ banners, bannersEnabled, fetchBanners, hasUniversalBanners = false, productId, isPaginationEnabled, remainingInventoryIds, queryParamsObject }: Props) {
  if (!bannersEnabled) {
    return null;
  }

  if (!bannersEnabled || !(banners && banners.length > 0)) {
    return null;
  }

  return (
    <Loadable
      banners={banners}
      hasUniversalBanners={hasUniversalBanners}
      fetchBanners={fetchBanners}
      productId={productId}
      isPaginationEnabled={isPaginationEnabled}
      remainingInventoryIds={remainingInventoryIds}
      queryParamsObject={queryParamsObject}
    />
  );
}

export default Switch;
